import React, { useContext } from "react"
import { StaticImage } from "gatsby-plugin-image"
import ReactSelect from "react-select"
import InputRange from "react-input-range"
import "./searchPageAside.scss"
import { GlobalAuthContext } from "../../../context/authContext"
import axios from "../../../constants/axios"

export default function SearchPageAsideFilter(props) {
  const {
    query_params,
    experienceLevel,
    salary,
    jobLocation,
    job_type,
    seniority_level,
    handleJobTypeChange,
    handleSeniorityLevelChange,
    handleLocationChange,
    handleSalaryChange,
    handleExperienceChange,
  } = props

  const [loading, setLoading] = React.useState(false)
  const [experience, setExperience] = React.useState({
    min: 0,
    max: 5,
  })

  const getConfigList = async () => {
    setLoading(true)
    const res = await axios.get("https://api.wdnexus.com/api/config/config/")

    if (res?.status === 200) {
      dispatch({
        type: "SET_CONFIG",
        payload: res.data,
      })
      setLoading(false)
    }
  }

  React.useEffect(() => {
    getConfigList()
  }, [])

  const { state, dispatch } = useContext(GlobalAuthContext)

  const districtsList = state.config?.country?.flatMap(item =>
    item.province.flatMap(prov => prov.districts)
  )

  const seniorityValue = [
    {
      id: 1,
      name: "All",
    },
    {
      id: 2,
      name: "Entry Level",
    },
    {
      id: 3,
      name: "Mid Level",
    },
    {
      id: 4,
      name: "Senior Level",
    },
  ]

  return (
    <aside className="wdn-filter-aside">
      <div className="filter-field select-filter-field">
        <h6 htmlFor="location">Location</h6>

        <div className=" bordered-select-field with-left-icon">
          <div className="ff-left-icon">
            {/* <img className="img-fluid" src={locationIcon} alt="" /> */}
            <StaticImage
              src="../../../images/location.svg"
              className="img-fluid"
              alt=""
            />
          </div>
          <ReactSelect
            className="select-element"
            isSearchable
            onChange={selectedOption => {
              handleLocationChange(selectedOption)
            }}
            value={jobLocation}
            options={districtsList}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        </div>
      </div>

      <div className="filter-field">
        <h6>Job Type</h6>

        <div className="ff-checkbox-fields">
          {state.config?.job_type.map((type, index) => (
            <label key={type.id}>
              <input
                type="checkbox"
                value={type.name}
                onChange={e => {
                  const isChecked = e.target.checked

                  if (isChecked) {
                    handleJobTypeChange([...job_type, type])
                  } else {
                    handleJobTypeChange(
                      job_type.filter(item => item.id !== type.id)
                    )
                  }
                }}
                checked={job_type?.some(item => item.id === type.id)}
              />
              {type.name}
            </label>
          ))}
        </div>
      </div>
      <div className="filter-field">
        <h6>Seniority Level</h6>

        <div className="ff-checkbox-fields">
          {seniorityValue.map((type, index) => (
            <label key={type.id}>
              <input
                type="checkbox"
                value={type.name}
                onChange={e => {
                  const isChecked = e.target.checked
                  const name = e.target.value
                  if (isChecked) {
                    handleSeniorityLevelChange([...seniority_level, type])
                  } else {
                    handleSeniorityLevelChange(
                      seniority_level.filter(item => item.id !== type.id)
                    )
                  }
                }}
                checked={seniority_level?.some(item => item.id === type.id)}
              />
              {type.name}
            </label>
          ))}
        </div>
      </div>
      <div className="filter-field mb-40px">
        <h6>Experience</h6>

        {/* <RangeInputField
          filterValue={filterValue}
          setRangeValue={handleFilterValueChange}
        /> */}
        {state.config?.experience && (
          <InputRange
            maxValue={Number(state.config.experience.length) - 1}
            minValue={0}
            formatLabel={value => `${value}yrs`}
            value={{
              min: Number(experience.min),
              max: Number(experience.max),
            }}
            onChange={value => {
              setExperience(value)
            }}
            onChangeComplete={value => {
              handleExperienceChange(value)
            }}
          />
        )}
      </div>
      <div className="filter-field">
        <h6>Expected Salary *</h6>

        <div className="row">
          <div className="col-6">
            <input
              key="minSalary"
              type="number"
              placeholder="Min"
              min={0}
              value={salary.min}
              onChange={e => {
                handleSalaryChange({
                  ...salary,
                  min: e.target.value,
                })
              }}
            />
          </div>
          <div className="col-6">
            <input
              key="maxSalary"
              type="number"
              placeholder="Max"
              min={0}
              value={salary.max}
              onChange={e => {
                handleSalaryChange({
                  ...salary,
                  max: e.target.value,
                })
              }}
            />
          </div>
        </div>
      </div>
    </aside>
  )
}
